import styled from '@emotion/styled'

// This tag is useful for example creating a series of literal
// Dx checkboxes from the Filemaker whose concepts are necessary but whose
// UI controls are actually supposed to be hidden in the real app

const L4Hidden = styled.div({
	display: 'none',
})

export default L4Hidden
